import { z } from "zod";

export const PhraseSchema = z
  .object({
    id: z.string().min(1),
    marker: z.string().regex(/^R\d{3,}$/),
    index: z.number().int().nonnegative(),
    clauseId: z.string().min(1),
    text: z.string().min(1),
    speechText: z.string().min(1).optional(),
    startOffset: z.number().int().nonnegative(),
    endOffset: z.number().int().positive(),
  })
  .readonly();

export const LessonSchema = z
  .object({
    id: z.string().min(1),
    version: z.string().min(1),
    title: z.string().min(1),
    voiceId: z.string().min(1),
    voiceModel: z.string().min(1).default("s2.1-pro"),
    locale: z.literal("ko-KR"),
    uiLocale: z.literal("en"),
    sourceHash: z.string().regex(/^[a-f0-9]{64}$/),
    normalizedText: z.string().min(1),
    utf8Bytes: z.number().int().positive(),
    phrases: z.array(PhraseSchema).min(1).readonly(),
    status: z.literal("compiled"),
    alignmentStatus: z.literal("unmeasured"),
    sourceSnapshotId: z.string().nullable(),
  })
  .readonly();

export const LessonMetadataSchema = z.object({
  title: z.string().trim().min(1).max(200).default("Untitled lesson"),
  voiceId: z.string().trim().min(1).max(200).default("19fd4cce31df400c8b4a0a076b79305f"),
  voiceModel: z.string().trim().min(1).max(80).default("s2.1-pro"),
  locale: z.literal("ko-KR").default("ko-KR"),
  sourceSnapshotId: z.string().nullable().default(null),
});

export type Phrase = z.infer<typeof PhraseSchema>;
export type Lesson = z.infer<typeof LessonSchema>;
export type LessonMetadata = z.input<typeof LessonMetadataSchema>;

export class DomainError extends Error {
  constructor(
    readonly code: "invalid_script" | "invalid_state",
    message: string,
  ) {
    super(message);
    this.name = "DomainError";
  }
}
